import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import StringConstant from '../../../constants/StringConstants';
import DateUtils from '../../../utils/DateUtils';
import config from '../../../config';
import { ToolTipComponent } from '../../common/ToolTipComponent';
import NumberUtils from '../../../utils/NumberUtils';
import SvgIcon from '../../common/SvgIcon';
import UserManagementStore from '../../../stores/UserManagementStore';

let _isNominatedUser = false;

const SVGImage = (
  <a
    href="javascript:;"
    className="tooltip-icon"
    aria-label="Information"
    role="button"
  >
    <SvgIcon id="icon-Information" width="20px" height="20px" />
  </a>
);

/**
 * @todo
 * This component is of poorquality.
 * Future improvement work can be done address this.
 */
class CustomComponentActive extends Component {
  constructor(props) {
    super(props);

    this.getNominatedUser = this.getNominatedUser.bind(this);
    this.viewClick = this.viewClick.bind(this);
    this.cancelClick = this.cancelClick.bind(this);
    this.editClick = this.editClick.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
    _isNominatedUser = UserManagementStore.isNominatedUser();
  }

  getNominatedUser() {
    if (_isNominatedUser) return null;
    else
      return (
        <a href="javascript:void(0)" onClick={this.cancelClick}>
          Cancel
          <span className="u-visually-hidden off-screen">
            {this.props.rowData.toAccountName}
          </span>
        </a>
      );
  }

  // click event of the cell of row except edit button
  viewClick(e) {
    this.props.customClick(this.props.rowData, 'VIEW', e);
  }

  cancelClick(e) {
    this.props.customClick(this.props.rowData, 'CANCEL', e);
  }

  editClick(e) {
    this.props.customClick(this.props.rowData, 'EDIT', e);
  }

  // Returns the cell based on columnName
  render() {
    switch (this.props.metadata.columnName) {
      case 'toAccountName':
        return (
          <div className="custom-column" onClick={this.viewClick}>
            {this.props.rowData.toAccountName},<br />
            {this.props.rowData.reference}
          </div>
        );
      case StringConstant.mpAmount:
        return (
          <div className="custom-column" onClick={this.viewClick}>
            {_.isNumber(this.props.rowData.amount)
              ? NumberUtils.decimalFormat(this.props.rowData.amount, 3, true)
              : StringConstant.unAvailable}
          </div>
        );
      case StringConstant.Type:
        return (
          <div className="custom-column" onClick={this.viewClick}>
            {this.props.data}
          </div>
        );
      case 'option':
        let editInfo = null;
        const hasSvg = true;
        switch (this.props.rowData.category) {
          case 'DD':
            if (
              this.props.rowData['showIcon'] &&
              this.props.rowData.showIcon &&
              !_isNominatedUser
            ) {
              editInfo = (
                <ToolTipComponent
                  className="info-icon"
                  hasSvg={hasSvg}
                  trigger="manual"
                  childComponent={SVGImage}
                  placement="bottom"
                  popoverChildComponent={
                    <p
                      dangerouslySetInnerHTML={{
                        __html: this.props.content.toolTipMessageDD,
                      }}
                    />
                  }
                />
              );
            }
            break;
          default:
            if (_isNominatedUser) {
              editInfo = '';
            } else if (this.props.rowData.isSoWrite) {
              editInfo = (
                <a href="javascript:void(0)" onClick={this.editClick}>
                  Edit
                  <span className="u-visually-hidden off-screen">
                    {this.props.rowData.toAccountName}
                  </span>
                </a>
              );
            } else {
              editInfo = (
                <ToolTipComponent
                  className="info-icon"
                  hasSvg={hasSvg}
                  trigger="manual"
                  childComponent={SVGImage}
                  placement="bottom"
                  popoverChildComponent={
                    <p
                      dangerouslySetInnerHTML={{
                        __html: this.props.content.toolTipMessageComplexSO,
                      }}
                    />
                  }
                />
              );
            }
        }
        return (
          <div>
            <a href="javascript:void(0)" onClick={this.viewClick}>
              View
              <span className="u-visually-hidden off-screen">
                {this.props.rowData.toAccountName}
              </span>
            </a>{' '}
            {this.getNominatedUser()} {editInfo}
          </div>
        );
      case 'when':
        if (this.props.data !== undefined) {
          let endDate = DateUtils.getMomentFromDateString(
            this.props.rowData.when
          );
          endDate = moment(endDate).format(config.dateFormatTimeline);

          if (endDate === StringConstant.INVALID_DATE)
            endDate = StringConstant.unAvailable;

          return (
            <div className="custom-column" onClick={this.viewClick}>
              {endDate}
            </div>
          );
        } else
          return (
            <div className="custom-column" onClick={this.viewClick}>
              -
            </div>
          );
      default:
        return (
          <div className="custom-column" onClick={this.viewClick}>
            {this.props.data}
          </div>
        );
    }
  }
}

CustomComponentActive.propTypes = {
  rowData: PropTypes.object,
  content: PropTypes.object,
  metadata: PropTypes.object,
  data: PropTypes.string || PropTypes.number,
  customClick: PropTypes.func,
};

export { CustomComponentActive };
